import { render } from "./DORADashboard.vue?vue&type=template&id=688e8814"
import script from "./DORADashboard.vue?vue&type=script&lang=js"
export * from "./DORADashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__